import apis from "../../core/apis.js";

class BiddingCampaignsResource {
  constructor($resource) {
    "ngInject";

    this.$resource = $resource;
  }

  getCityConfiguration(cityId) {
    return this.$resource(
      apis.biddingCampaigns + `city_bid_configurations/${cityId}`
    ).get();
  }

  updateCityConfiguration(cityId, params) {
    return this.$resource(
      apis.biddingCampaigns + `city_bid_configurations/${cityId}`,
      null,
      {
        update: { method: "PATCH" },
      }
    ).update(params);
  }
}

export default BiddingCampaignsResource;



// WEBPACK FOOTER //
// ./src/resources/biddingCampaigns/biddingCampaigns.resource.js